import { useState } from 'react'
import { fetcher, AdminTreasureGameOpportunitiesEndpoints, IUseTreasureGameOpportunities } from '@olagg/api-hooks'
import { AdminTreasureGameOpportunity } from '@olagg/db-types'

interface OpportunitiesResponse {
  treasureOpportunities: AdminTreasureGameOpportunity[]
  meta: {
    count: number
  }
}

const useTreasureGameOpportunities = () => {
  const [loading, setLoading] = useState(false)

  const getTreasureOpportunities = async (filter: IUseTreasureGameOpportunities): Promise<OpportunitiesResponse> => {
    try {
      setLoading(true)
      const endpoint = AdminTreasureGameOpportunitiesEndpoints.all(filter)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching treasure game opportunities:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getTreasureOpportunity = async (id: string): Promise<AdminTreasureGameOpportunity> => {
    try {
      setLoading(true)
      const endpoint = AdminTreasureGameOpportunitiesEndpoints.show(id)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching treasure game opportunity:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const createTreasureOpportunity = async (data: Partial<AdminTreasureGameOpportunity>): Promise<any> => {
    try {
      setLoading(true)
      const endpoint = AdminTreasureGameOpportunitiesEndpoints.create(data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error creating treasure game opportunity:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updateTreasureOpportunity = async (id: string, data: Partial<AdminTreasureGameOpportunity>): Promise<any> => {
    try {
      setLoading(true)
      const endpoint = AdminTreasureGameOpportunitiesEndpoints.update(id, data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error updating treasure game opportunity:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const deleteTreasureOpportunity = async (id: string): Promise<void> => {
    try {
      setLoading(true)
      const endpoint = AdminTreasureGameOpportunitiesEndpoints.destroy(id)
      await fetcher(endpoint)
    } catch (error) {
      console.error('Error deleting treasure game opportunity:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    getTreasureOpportunities,
    getTreasureOpportunity,
    createTreasureOpportunity,
    updateTreasureOpportunity,
    deleteTreasureOpportunity,
  }
}

export default useTreasureGameOpportunities